import styled from "styled-components";

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.8);
  backdrop-filter: blur(10px);

  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  padding: 16px;
  transition: all 0.3s ease-in-out;
  opacity: ${(props) => (props.$isAnimating ? 1 : 0)};
`;
export const TitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
`;
export const ModalContainer = styled.div`
  width: calc(100% - 32px);
  max-width: 572px;
  position: absolute;
  top: 50%;
  left: 50%;
  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.5);
  overflow: hidden;
  max-height: 90vh;
  overflow-y: auto;

  opacity: ${({ $isAnimating }) => ($isAnimating ? 1 : 0)};
  transform: ${({ $isAnimating }) =>
    $isAnimating
      ? "translate(-50%, -50%) scale(1) translateY(0)"
      : "translate(-50%, -50%) scale(0.8) translateY(50px)"};
  transition: all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);

  border-radius: 24px;
  border: 1px solid #18181b;
  background: #18181b;
`;

export const ModalContent = styled.div`
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const ModalTitle = styled.h2`
  color: #fff;
  font-family: Figtree;

  font-size: 15px;

  font-weight: 400;
  line-height: 20px; /* 133.333% */
  opacity: 0.5;
`;

export const Row = styled.div`
  display: flex;

  flex-direction: row;
  align-items: center;
  margin-bottom: 15px;
  gap: 10px;
`;

export const CloseButton = styled.button`
  margin-left: auto;
  background: ${({ theme }) =>
    theme === "light" ? "rgba(0, 0, 0, 0.1)" : "rgba(255, 255, 255, 0.1)"};
  border: none;
  color: ${({ theme }) => (theme === "light" ? "#1a1a1a" : "white")};
  min-width: 40px;
  max-width: 40px;
  min-height: 40px;
  max-height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.3s ease;
  z-index: 10;

  &:hover {
    background: ${({ theme }) =>
      theme === "light" ? "rgba(0, 0, 0, 0.15)" : "rgba(255, 255, 255, 0.2)"};
  }
`;

export const NoticeList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const NoticeText = styled.span`
  color: #fff;
  font-family: Figtree;
  font-size: 16px;
  font-weight: 400;
  line-height: 20px; /* 125% */
  white-space: nowrap;
  @media (max-width: 650px) {
    white-space: unset;
  }
`;
export const NoticeItem = styled.div`
  display: flex;
  gap: 4px;
  flex-direction: row;
  align-items: center;
  width: fit-content;
  padding: 12px;
  border-radius: 24px;
  background: #2f2f35;
  @media (max-width: 650px) {
    width: 100%;
  }
`;

export const FooterText = styled.p`
  color: #fff;
  font-family: Inter;
  font-size: 15px;
  font-weight: 400;
  opacity: 0.3;
  text-align: center;
`;

export const LinkText = styled.span`
  color: #2877D9;
  cursor: pointer;
  text-decoration: underline;
  transition: color 0.3s ease;

  &:hover {
    color: #38f9d7;
  }
`;

export const ContinueButton = styled.button`
  display: flex;
  width: 180px;
  height: 40px;
  padding: 12px 44px;
  justify-content: center;
  align-items: center;
  align-self: center;
  gap: 10px;

  cursor: pointer;
  border-radius: 100px;
  background: #fff;

  color: #09090b;
  font-family: Figtree;

  font-size: 14px;
  font-weight: 500;
  letter-spacing: -0.21px;

  transition: all 0.3s ease;

  flex-direction: row;

  &:hover {
    transform: translateY(-2px);
  }

  &:active {
    transform: translateY(0);
  }
`;

export const ModalText = styled.span`
  font-size: 14px;
  line-height: 1.6;
  margin: 0;
  color: ${({ theme }) =>
    theme === "light" ? "rgba(0, 0, 0, 0.7)" : "rgba(255, 255, 255, 0.8)"};
`;
